<div class="sidebar d-flex flex-column justify-content-between h-100 py-4">

  <div>
    <div class="d-flex align-items-center px-4">
      <img class="logo me-2" src="assets/logo/gks-dark.svg" [alt]="'app.name'|translate">
      <span class="fs-xsmall fw-800 color-brand-primary">{{'app.panel_name'|translate|uppercase}}</span>
    </div>

    <div class="w-100 mt-5 px-3">
      <ng-container *ngFor="let item of navItems">
        <a
          class="nav-item d-flex w-100 align-items-center color-gray-500 clickable"
          [class.active]="isActive(item)"
          [routerLink]="item.url" (click)="onNavigate()">
          <gray-icon icon="{{item.icon}}"></gray-icon>
          <p class="ms-2 fs-normal fw-500 mb-0">{{item.titleKey|translate}}</p>
          <span *ngIf="badgeCount(item) > 0"
                class="nav-badge ms-auto bg-red-500 color-gray-50 fs-xsmall fw-800"
                [attr.aria-label]="'messages.unread_badge'|translate: {count: badgeCount(item)}">
            {{badgeLabel(badgeCount(item))}}
          </span>
        </a>
      </ng-container>
    </div>
  </div>

  <div class="px-3" *ngIf="coach$|async as coach">
    <p class="fs-xsmall fw-800 color-gray-400 mb-2 ms-1">{{'menu.account'|translate|uppercase}}</p>

    <a
      class="coach-card d-flex align-items-center p-3 clickable"
      [class.active]="activeUrl.startsWith('/dashboard/account')"
      routerLink="/dashboard/account" (click)="onNavigate()">
      <app-user-profile-img
        [image]="coach.profilePhoto" width="40px" height="40px"></app-user-profile-img>
      <div class="ms-2 flex-grow-1 overflow-hidden">
        <p class="fs-small fw-800 color-gray-950 mb-0 text-truncate">{{coach.name}}</p>
        <p class="fs-xsmall fw-400 color-gray-400 mb-0 text-truncate">{{coach.coachProfile?.specialization}}</p>
      </div>
      <gray-icon class="card-arrow color-gray-400 ms-2" icon="arrow-right"></gray-icon>
    </a>

    <a class="nav-item d-flex w-100 align-items-center color-gray-500 clickable mt-2" (click)="logout()">
      <i class="bi bi-box-arrow-right fs-20"></i>
      <p class="ms-2 fs-normal fw-500 mb-0">{{'buttons.logout'|translate}}</p>
    </a>
  </div>

</div>
